import {useStyles} from "../styles/OddListeningStepStyle";
import {Box, Typography} from "@material-ui/core";
import React from "react";
import {withRouter} from "react-router-dom";
import {inject, observer} from "mobx-react";

function DividedTextBox(props) {
    const classes = useStyles();
    const oddStepOneStore = props.oddStepOneStore;
    const content = oddStepOneStore.getSelectedContent();
    const topPieceList = content.topPieceList;
    const bottomPieceList = content.bottomPieceList;

    return (
        <>
            <Box className={classes.textContnetScroll}>
                <Box className={classes.textContnetBox}>
                    <Typography>본문 1</Typography>

                    {/*TODO 클라이언트 요청으로 인해 더 많이 나누는 문장을 상단으로 설정하도록 적용 */}
                    <Box className={classes.textContnet}>
                        {bottomPieceList.length > 0 ? bottomPieceList.map((piece, index) => (
                                <Box key={index}>
                                    <Typography style={{width: '100%'}} variant={'body1'}>{oddStepOneStore.getDividedText(piece.textStartIndex, piece.textEndIndex)}</Typography>
                                </Box>
                            )) :
                            <Box>
                                <Typography>나누어진 문장이 없습니다. 문장을 나누어 주세요.</Typography>
                            </Box>
                        }
                    </Box>
                    {/*TODO 클라이언트 요청으로 인해 더 많이 나누는 문장을 상단으로 설정하도록 적용 */}



                </Box>
                <Box className={classes.textContnetBox}>

                    <Typography>본문 2</Typography>
                    {/*TODO 클라이언트 요청으로 인해 더 적게 나누는 문장을 하단으로 설정하도록 적용 */}
                    <Box className={classes.textContnet}>
                        {topPieceList.length > 0 ? topPieceList.map((piece, index) => (
                                <Box key={index}>
                                    <Typography style={{width: '100%'}} variant={'body1'}>{oddStepOneStore.getDividedText(piece.textStartIndex, piece.textEndIndex)}</Typography>
                                </Box>
                            )) :

                            <Box>
                                <Typography>나누어진 문장이 없습니다. 문장을 나누어 주세요.</Typography>
                            </Box>
                        }
                    </Box>
                    {/*TODO 클라이언트 요청으로 인해 더 적게 나누는 문장을 하단으로 설정하도록 적용 */}


                </Box>
            </Box>
        </>
    )
}

export default withRouter(inject('contentStore','oddStepOneStore')(observer(DividedTextBox)));
